import React from 'react'

const Logo = () => (
  <img src={require('../assets/logo.svg')} style={{ width: '125px' }} />
)

export default Logo
